/** 
 * 使用sign添加验签后发送请求
*/
async function setH5GuardSign(options) {
    const { headers = {} } = options;
    try {
        if (window.H5guard) {
            const h5GuardSignRes = await window.H5guard.sign(options) || {};
            headers.mtgsig = h5GuardSignRes.headers ? h5GuardSignRes.headers.mtgsig : '';
            if (!headers['content-encoding']) {
                headers['content-encoding'] = ''; // 没有则传入空''字符串，兼容老版本KNB
            }
        } else {
            console.warn('window.H5guard is not exist!')
        }
        return headers;
    } catch (error) {
        return headers;
    }

}

export {
    setH5GuardSign
}
